module.exports = __webpack_public_path__ + "img/Mercedes-banner-s-1.aaca110f.jpg";